
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import {pathConstants} from "../../../shared/pathConstants";

export const loginService = {
    login,
    logout,
    refreshToken,
    requestResetPassword
};

const uninterceptedAxiosInstance = axios.create();

function login(data) {
     return axios.post(pathConstants.API +'/authenticate', data, {headers: {publicService: true}})
        .then(result => {
            return result.data;
        }, err => {
            return Promise.reject(err.response.data.detail);
        });
}

function logout() {
    return axios.get(pathConstants.API + '/users/logout')
        .then(() => {
            // console.log('logOut');
        }, err => {
            return Promise.reject(err);
        });
}

function requestResetPassword(email) {
    return axios.post(pathConstants.API + '/accounts/forget-password', email, {
            headers: {
                'content-type': 'text/plain',
                publicService: true
            },
        })
        .then(() => {
            return true;
        }, err => {
            return Promise.reject(err.response.data.detail);
        });

}

function refreshToken() {
    return uninterceptedAxiosInstance.post(pathConstants.API + '/users/refresh-token')
        .then(() => {
            // console.log('refresh token');
        }, err => {
            return Promise.reject(err);
        });
}
